export default __webpack_public_path__ + "static/media/heart.5754dd99.svg";